module.exports = __webpack_public_path__ + "static/media/item-shared-info-active.2a1ef62a.svg";